import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  AppButton,
  Box,
  Inscription,
  Preloader,
  useResponsive,
  WarningCard,
  WarningIcon,
} from '@common-fe/common-fe';

import { ModalWrapper } from '@/components/wrappers';

interface Props {
  title: string;
  subTitle: string;
  warningText: React.ReactNode;
  form: React.ReactNode;
  isLoading: boolean;
  errorText?: string;
  isNextButtonDisabled?: boolean;
  onSetVisible: (value: boolean) => void;
  onNext: () => void;
  onCancel: () => void;
}

const VerificationModal: React.FC<Props> = ({
  title,
  subTitle,
  warningText,
  form,
  isLoading,
  errorText,
  isNextButtonDisabled,
  onSetVisible,
  onNext,
  onCancel,
}) => {
  const { t } = useTranslation();
  const { isMobile } = useResponsive();
  return (
    <ModalWrapper visible onSetVisible={onSetVisible} title={title}>
      <Inscription textAlign="center" margin={{ horizontal: 'spacing8' }}>
        {subTitle}
      </Inscription>

      <Box
        margin={{ top: 'spacing16' }}
        background="module"
        pad={isMobile ? 'spacing8' : 'spacing24'}
        round="moduleRound"
      >
        <Box background="canvas" round="container1Round">
          <div>{form}</div>
        </Box>

        <Box margin={isMobile ? { top: 'spacing16' } : { top: 'spacing24' }}>
          <WarningCard
            icon={<WarningIcon />}
            title={warningText}
            background="canvas"
            topBorderMargin="spacing12"
            pad="spacing12"
            containerProps={{
              pad: { vertical: 'spacing16', horizontal: 'spacing24' },
            }}
          />
        </Box>
      </Box>

      <Box margin={isMobile ? { top: 'spacing16' } : { top: 'spacing24' }}>
        {errorText && (
          <Inscription margin={{ bottom: 'spacing12' }} color="danger" textAlign="end">
            {errorText}
          </Inscription>
        )}
        <Box direction={isMobile ? 'column-reverse' : 'row'} justify="end" gap="spacing8">
          <AppButton
            testId="cancel"
            width={isMobile ? '100%' : '160px'}
            buttonType="secondary"
            onClick={onCancel}
          >
            {t('Cancel')}
          </AppButton>

          <AppButton
            testId="next"
            width={isMobile ? '100%' : '160px'}
            disabled={isNextButtonDisabled}
            {...(isLoading ? {} : { onClick: onNext })}
          >
            {isLoading ? <Preloader /> : t('Next')}
          </AppButton>
        </Box>
      </Box>
    </ModalWrapper>
  );
};

export default VerificationModal;
